module.exports = __webpack_public_path__ + "static/media/owen-valentine.dc48e403.md";